var map = {
	"./Alpha Bank.png": 329,
	"./American Bank of Investments.png": 330,
	"./BKT.png": 331,
	"./Credins Bank.png": 332,
	"./First Investment Bank.png": 333,
	"./Intesa San Paolo.png": 154,
	"./Intesa SanPaolo.png": 334,
	"./OTP Bank.png": 335,
	"./ProCredit Bank.png": 336,
	"./Raiffeisen.png": 155,
	"./Tirana Bank.png": 337,
	"./Union Bank.png": 338,
	"./United Bank of Albania.png": 339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 211;